import Icon from '../../../components/AppIcon';

const MissionSection = () => {
  const sections = [
    {
      id: 1,
      icon: 'Users',
      title: 'من نحن؟',
      content: [
        'نحنُ مجموعةٌ من النِقاط. نؤمن أن النجاة جماعيّة، وأن لكل إنسانٍ قصةً تستحق أن تروى.']

    },
    {
      id: 2,
      icon: 'Eye',
      title: 'رؤيتنا',
      content: [
        'نحلمُ بمساحةٍ إبداعية توثّق التراث وتجدد المشهد الثقافي العربيّ، لأننا نحبُ اللغة العربيّة حُبَّين: حُبَ الهوى، وحبًا هي أهلٌ له.']

    },
    {
      id: 3,
      icon: 'HelpCircle',
      title: 'لماذا "دوائر" ؟',
      content: [
        'لأننا نؤمن أن الدائرة هي الشكلُ الهندسيُ الأكمل، وأن العلوم الإنسانية على اختلافها (أدب، فلسفة، علم نفس..) ما هي إلّا دوائر تُفضي إلى دوائر تُفضي إلى دوائر، وكلّها محاولات لتفسير الوجود دون تضييع المركز.']

    }];


  return (
    <section className="mt-8 mb-16 bg-[var(--color-card)]">
      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="space-y-4">
          {sections?.map((section) =>
            <div key={section?.id} className="p-6 bg-background rounded-2xl shadow-sm border border-border/50">
              <div className="flex items-center gap-4 mb-6 md:mb-8 mt-3">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[var(--color-accent)]/10 flex items-center justify-center">
                  <Icon name={section?.icon} size={24} color="var(--color-accent)" />
                </div>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-[var(--color-foreground)]">
                  {section?.title}
                </h2>
              </div>
              <div className="space-y-4 md:space-y-5">
                {section?.content?.map((paragraph, index) =>
                  <p key={index} className="text-base md:text-lg text-[var(--color-muted-foreground)] leading-relaxed font-body">
                    {paragraph}
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default MissionSection;